/* src/app/intro/intro.component.scss */
.general2 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.general2 .intro-box {
  width: 1070px;
  height: auto;
  border-radius: 30px;
  background-color: var(--dark-grey);
  margin-left: auto;
  margin-right: auto;
  top: 40px;
  text-align: left;
  padding: 30px 75px 30px 50px;
}
.general2 .intro-box h1 {
  font-size: 34px;
  margin-bottom: 20px;
}
.general2 .intro-box p {
  font-family: "Campton-Light";
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
}
.general2 .intro-box p span.strong {
  font-weight: bold;
}
.general2 .intro-box p a {
  text-decoration: underline;
}
.general2 .intro-box .submit-button {
  background-color: #6dcc09;
  border: none;
}
.general2 .intro-box a {
  text-decoration: underline;
}
.card {
  width: 1180px;
  height: 620px;
  background-color: #3d3f47;
  border-radius: 30px;
}
.card.card-noned {
  height: 580px;
}
.card.card-noned .item {
  height: 580px;
}
.card .item {
  padding: 50px;
  -webkit-user-select: none;
  user-select: none;
  height: 620px;
}
.card strong {
  font-family: "Campton-Bold";
}
.strong {
  font-family: "Campton-Bold";
}
.underline {
  text-decoration: underline;
}
.intro-container {
  margin-left: auto;
  margin-right: auto;
  max-width: 1180px;
  padding: 0px;
}
.intro-container .submit-button {
  margin-top: 20px;
}
.intro-container .left-align p {
  text-align: left;
}
.intro-container p {
  font-family: "Campton-Light";
  font-size: 20px;
  line-height: 30px;
  font-style: normal;
  font-weight: 400;
  text-align: center;
  margin-bottom: 20px;
}
.intro-container p.some-margin-top {
  margin-top: 25px;
}
.intro-container p.no-margin-bottom {
  margin-bottom: 0px;
}
.intro-container p.mbm {
  margin-bottom: 20px;
  margin-left: 115px;
  margin-right: 115px;
}
.intro-container p.sbm {
  margin-bottom: 20px;
  margin-left: 90px;
  margin-right: 90px;
}
.intro-container h1 {
  margin-bottom: 40px;
  text-align: left;
}
.intro-container h1.header-noned {
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
.intro-container .education .logos-container {
  padding-top: 25px;
}
.intro-container .logos-container {
  column-count: 4;
  justify-content: space-evenly;
  padding-bottom: 50px;
  height: 100%;
  padding-top: 25px;
}
.intro-container .logo-container {
  width: 240px;
  height: 120px;
  background: #272a33;
  border-radius: 10px;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  margin-bottom: 20px;
}
.intro-container .logo-container.logo-small {
  height: 110px;
}
.intro-container .para-header {
  font-family: "Campton-Semibold";
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 50px;
}
.intro-container .stats-container {
  column-count: 3;
  justify-content: space-evenly;
  margin-bottom: 50px;
}
.intro-container .stats-container .stat {
  width: 320px;
  height: 200px;
  background: #272a33;
  border-radius: 30px;
  font-family: "Campton";
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: center;
  padding: 40px 15px 15px 15px;
}
.intro-container .stats-container .stat.stat-adjust {
  padding-top: 55px;
}
.intro-container .stats-container .stat.stat-adjust:first-child {
  padding-top: 25px;
}
.intro-container .stats-container .stat .number {
  font-family: "Campton-Semibold";
  font-size: 50px;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 0em;
  text-align: center;
  color: #6dcc09;
}
.buttons {
  justify-content: space-between;
  display: flex;
}
.accessibility-alert {
  height: 50%;
}
/*# sourceMappingURL=intro.component.css.map */
